import { motion } from "framer-motion";

export const TextFadeAnimation = ({ text }: { text: string }) => {
  return (
    <div className="flex whitespace-pre">
      {text.split("").map((letter, index) => (
        <motion.span
          key={index}
          animate={{
            opacity: [0.5, 1, 0.5],
          }}
          className="text-lg text-foreground"
          initial={{ opacity: 0 }}
          transition={{
            delay: index * 0.03,
            duration: 2,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          }}
        >
          {letter}
        </motion.span>
      ))}
    </div>
  );
};
